import { getErrorCode, unknownToError } from "@vortex/shared";
import * as React from "react";
import { addNotification, showDialog } from "../../../actions/notifications";
import { setSettingsPage } from "../../../actions/session";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import ToolbarIcon from "../../../controls/ToolbarIcon";
import { TemporaryError, UserCanceled } from "../../../util/CustomErrors";
import { showError } from "../../../util/message";
import { activeGameId } from "../../../util/selectors";
import { getSafe } from "../../../util/storeHelper";
import { setConfirmPurge } from "../actions/settings";
import { NoDeployment } from "../util/exceptions";
const nop = () => undefined;
class DeactivationButton extends ComponentEx {
    render() {
        const { t, activator, buttonType } = this.props;
        return (React.createElement(ToolbarIcon, { icon: "purge", id: "purge-mods", text: t("Purge Mods"), onClick: activator !== undefined ? this.activate : this.noMethod }));
    }
    activate = () => {
        const { confirmPurge, onShowError } = this.props;
        const prom = confirmPurge !== false ? this.confirmPurge() : Promise.resolve();
        prom
            .then(() => new Promise((resolve, reject) => {
            this.context.api.events.emit("purge-mods", false, (err) => {
                if (err !== null) {
                    reject(err);
                }
                else {
                    this.context.api.sendNotification({
                        id: "mods-purged",
                        type: "info",
                        message: "Mods purged",
                        displayMS: 3000,
                    });
                    resolve();
                }
            });
        }))
            .catch((err) => {
            if (err instanceof UserCanceled) {
                // not sure how we'd get here, UserCanceled is caught further up!
                return;
            }
            if (err instanceof TemporaryError) {
                onShowError("Failed to purge mods, please try again", err.message, false);
                return;
            }
            if (err instanceof NoDeployment) {
                onShowError("You need to select a deployment method in settings", undefined, false);
                return;
            }
            const errCode = getErrorCode(err);
            if (errCode == null && err.errno !== undefined) {
                // unresolved windows error code
                onShowError("Failed to purge mods", {
                    error: err,
                    ErrorCode: err.errno,
                }, true);
            }
            else {
                const isFSErr = ["ENOTFOUND", "ENOENT", "EMFILE"].includes(errCode);
                if (isFSErr) {
                    const converted = unknownToError(err);
                    converted.message =
                        "A filesystem error prevented purging some files. " +
                            "please try purging again.\n" +
                            converted.message;
                    onShowError("Failed to purge mods", converted, !isFSErr);
                }
                else {
                    onShowError("Failed to purge mods", err, !isFSErr);
                }
            }
        });
    };
    noMethod = () => {
        const { onSetSettingsPage, onShowWarning } = this.props;
        onShowWarning("You have to select a deployment method first", {
            title: "Fix",
            action: (dismiss) => {
                this.context.api.events.emit("show-main-page", "application_settings");
                onSetSettingsPage("Mods");
                dismiss();
            },
        }, "select-deployment-method-first");
    };
    confirmPurge() {
        const { onSetConfirmPurge, onShowDialog } = this.props;
        return onShowDialog("question", "Confirm purge", {
            text: "Purging will remove all links deployed to the game directory.\n" +
                "This is not a destructive operation, on the next deployment all links will be " +
                "restored.\n" +
                "Use this operation to force a complete re-deployment or to restore the game " +
                "directory to an unmodded-state.",
            checkboxes: [
                { id: "confirm_purge", text: "Don't ask again", value: false },
            ],
        }, [{ label: "Cancel" }, { label: "Continue" }]).then((result) => {
            if (result.action === "Cancel") {
                return Promise.reject(new UserCanceled());
            }
            else {
                if (result.input.confirm_purge) {
                    onSetConfirmPurge(false);
                }
                return Promise.resolve();
            }
        });
    }
}
function mapStateToProps(state, ownProps) {
    const gameId = activeGameId(state);
    const activatorId = getSafe(state, ["settings", "mods", "activator", gameId], undefined);
    let activator;
    if (activatorId !== undefined) {
        activator = ownProps
            .getActivators()
            .find((act) => act.id === activatorId);
    }
    return {
        activator,
        confirmPurge: state.settings.mods.confirmPurge,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onShowError: (message, details, allowReport) => showError(dispatch, message, details, { allowReport }),
        onShowDialog: (type, title, content, dialogActions) => 
        // showDialog thunk returns Bluebird — see comment in notifications.ts
        Promise.resolve(dispatch(showDialog(type, title, content, dialogActions))),
        onSetConfirmPurge: (enabled) => dispatch(setConfirmPurge(enabled)),
        onShowWarning: (message, dialogAction, id) => dispatch(addNotification({
            id,
            type: "warning",
            message,
            actions: [dialogAction],
        })),
        onSetSettingsPage: (pageId) => dispatch(setSettingsPage(pageId)),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(DeactivationButton));
